import { apiAnuncioCrear, apiAnuncioDesactivar, apiAnuncioObtener } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import Moment from 'moment';
import {
    fnHandleChangeChek,
    fnHandleChangeDate,
    fnHandleChangeText,
    fnHandleChangeUDecimal,
    fnHandleChangeUInteger,
} from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormAnuncio, getModelAnuncio } from "../models/AnuncioModel";
import { green, red } from "@material-ui/core/colors";

import RedeemIcon from "@material-ui/icons/Redeem";
import { useCatalogo } from "./CatalogoContext";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const AnuncioContext = createContext();

export function AnuncioProvider(props) {
    const { entCatalogos } = useCatalogo();
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post, PostFormData } = useRequest();

    const [listaAnuncios, setListaAnuncios] = useState([]);
    const [anuncioSeleccionado, setAnuncioSeleccionado] = useState(getModelAnuncio());
    const [modalOpenFormAnuncio, setModalOpenFormAnuncio] = useState(false);
    const [modalOpenDetalleAnuncio, setModalOpenDetalleAnuncio] = useState(false);
    const [modalOpenEliminarAnuncio, setModalOpenEliminarAnuncio] = useState(false);
    const [formAnuncio, setFormAnuncio] = useState(getFormAnuncio());
    const [archivoCargado, setArchivoCargado] = useState(null);

    const handleOpenFormAnuncio = (value) => {
        setModalOpenFormAnuncio(value);
    };

    const handleOpenDetalleAnuncio = (value) => {
        setModalOpenDetalleAnuncio(value);
    };

    const handleOpenEliminarAnuncio = (value) => {
        setModalOpenEliminarAnuncio(value);
    };

    const handleChangeAnuncioSeleccionado = (value) => {
        setAnuncioSeleccionado(value);
    };

    const handleChangeFormAnuncioText = fnHandleChangeText(formAnuncio, setFormAnuncio);
    const handleChangeFormAnuncioUInt = fnHandleChangeUInteger(formAnuncio, setFormAnuncio);
    const handleChangeFormAnuncioUDec = fnHandleChangeUDecimal(formAnuncio, setFormAnuncio);
    const handleChangeFormAnuncioCheck = fnHandleChangeChek(formAnuncio, setFormAnuncio);
    const handleChangeFormAnuncioFecha = fnHandleChangeDate(formAnuncio, setFormAnuncio);

    const handleClickNuevoAnuncio = () => {
        const anuncio = getModelAnuncio();
        setAnuncioSeleccionado(anuncio);
        setFormAnuncio(getFormAnuncio());
        setModalOpenFormAnuncio(true);
    };

    const handleClickEditarAnuncio = () => {
        if (anuncioSeleccionado.iIdAnuncio === 0) {
            handleOpenAlert("Seleccione un anuncio para ver el detalle");
            return;
        }
        fnFillFormulario(anuncioSeleccionado);
        setModalOpenFormAnuncio(true);
    };

    const handleClickDetalleAnuncio = () => {
        if (anuncioSeleccionado.iIdAnuncio === 0) {
            handleOpenAlert("Seleccione un anuncio para ver el detalle");
            return;
        }
        //console.log(anuncioSeleccionado);
        setModalOpenDetalleAnuncio(true);
    };

    const handleClickEliminarAnuncio = () => {
        if (anuncioSeleccionado.iIdAnuncio === 0) {
            handleOpenAlert("Seleccione un anuncio para eliminar");
            return;
        }
        setModalOpenEliminarAnuncio(true);
    };

    const handleClickRefrescarDatos = () => {
        fnObtenerAnuncios();
    };

    const handleClickCargarArchivo = () => {
        setArchivoCargado(null);
        if (formAnuncio.txtCatAnuncio.value !== 0) {
            //Buscamos la informacion del tipo de archivo
            let stipoarchivo = "*";
            let ialto = 0;
            let iancho = 0;
            let itamniomax = 0;
            entCatalogos.catAnuncios.forEach((element) => {
                if (element.fiId === formAnuncio.txtCatAnuncio.value) {
                    stipoarchivo = element.sTipo;
                    ialto = element.iAlto;
                    iancho = element.iAncho;
                    itamniomax = element.iTamanioMax;
                }
            });

            let input = document.createElement("input");
            input.type = "file";
            input.value = "";
            input.accept = "image/" + stipoarchivo;
            input.addEventListener("change", async () => {
                let archivo = input.files[0];
                if (!archivo) {
                    handleOpenAlert("No se cargó ningún archivo");
                    return;
                }
                if (archivo.size > itamniomax * 1000) {
                    handleOpenAlert("El tamaño excede al configurado " + itamniomax / 1000 + " MB");
                    return;
                }
                if (archivo.type.toLowerCase().indexOf(stipoarchivo.toLowerCase()) > -1) {
                    var _URL = window.URL || window.webkitURL;
                    var img = new Image();
                    img.src = _URL.createObjectURL(archivo);
                    img.onload = function () {
                        var ancho = img.width;
                        var alto = img.height;
                        if (ialto != alto || ancho != iancho) {
                            handleOpenAlert("Las dimensiones del archivo deben ser: " + iancho + " x " + ialto);
                            return;
                        }
                        const { txtArchivo } = formAnuncio;
                        setArchivoCargado(archivo);
                        setFormAnuncio({
                            ...formAnuncio,
                            txtArchivo: { ...txtArchivo, value: archivo.name, error: false },
                        });
                    };
                } else {
                    handleOpenAlert("El formato del archivo no es " + stipoarchivo);
                }
            });
            input.click();
            input.remove();
        } else {
            handleOpenAlert("Selecciona el grupo de anuncio primero");
        }
    };

    const handleSubmitFormAnuncio = (e) => {
        fnPrevent(e);
        const { txtCatAnuncio, txtFechaInicio, txtFechaVencimiento, txtDuracion, txtArchivo } = formAnuncio;
        const iDuracion = parseInt(txtDuracion.value);
        if (anuncioSeleccionado.iIdAnuncio === 0) {
            const form = {
                ...formAnuncio,
                txtDuracion: {
                    ...txtDuracion,
                    error: isNaN(iDuracion) || iDuracion <= 0,
                },
                txtArchivo: {
                    ...txtArchivo,
                    error: txtArchivo.value === "",
                },
            };
            setFormAnuncio(form);
            if (
                Object.values(form)
                    .map((x) => x.error)
                    .includes(true)
            ) {
                return;
            }
        } else {
            const form = {
                ...formAnuncio,
                txtDuracion: {
                    ...txtDuracion,
                    error: isNaN(iDuracion) || iDuracion <= 0,
                },
            };
            setFormAnuncio(form);
            if (
                Object.values(form)
                    .map((x) => x.error)
                    .includes(true)
            ) {
                return;
            }
        }

        const entCreateAnuncio = {
            iIdAnuncio: anuncioSeleccionado.iIdAnuncio,
            iIdCatAnuncio: parseInt(txtCatAnuncio.value),
            iDuracion: parseInt(txtDuracion.value),
            dtFechaInicio: Moment(txtFechaInicio.value).format('YYYY-MM-DD HH:mm:ss'),
            dtFechaVencimiento: Moment(txtFechaVencimiento.value).format('YYYY-MM-DD HH:mm:ss'),
        };
        //console.log(archivoCargado);
        fnGuardarAnuncio(entCreateAnuncio, archivoCargado);
    };

    const handleSubmitEliminarAnuncio = () => {
        fnElimninarAnuncio(anuncioSeleccionado.iIdAnuncio);
    };

    const fnObtenerAnuncios = async (piIdAnuncio = null) => {
        const payload = {
            loader: "Consultando anuncios...",
            url: apiAnuncioObtener + "?piIdAnuncio=" + piIdAnuncio,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const resListaAnuncios = response.Result.map((anuncio) => ({
                ...anuncio,
            }));
            setListaAnuncios(resListaAnuncios);
        }
    };

    const fnGuardarAnuncio = async (entAnuncio, archivofile = new File()) => {
        var formData = new FormData();
        formData.append("archivo", archivofile);
        formData.append("data", JSON.stringify(entAnuncio));
        formData.append("idUsuario", usuarioSesion.iIdUsuario);
        const payload = {
            loader: "Guardando anuncio...",
            url: apiAnuncioCrear,
            body: formData,
            alert: true,
        };

        const response = await PostFormData(payload);
        if (response.Code === 0) {
            setArchivoCargado(null);
            setModalOpenFormAnuncio(false);
            setAnuncioSeleccionado(getModelAnuncio());
            await fnObtenerAnuncios();
        }
        fnPreventBlur();
    };

    const fnElimninarAnuncio = async (piIdAnuncio) => {
        const payload = {
            loader: "Eliminando anuncio...",
            url: apiAnuncioDesactivar + "?piIdAnuncio=" + piIdAnuncio + "&piIdUsuario=" + usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarAnuncio(false);
            setAnuncioSeleccionado(getModelAnuncio());
            await fnObtenerAnuncios();
        }
        fnPreventBlur();
    };

    const fnFillFormulario = (anuncio) => {
        const {
            txtCatAnuncio,
            chkFechaInicio,
            txtFechaInicio,
            chkFechaVencimiento,
            txtFechaVencimiento,
            txtDuracion,
            txtArchivo,
        } = getFormAnuncio();

        setFormAnuncio({
            ...formAnuncio,
            txtCatAnuncio: {
                ...txtCatAnuncio,
                value: !anuncio.iIdCatAnuncio ? "" : anuncio.iIdCatAnuncio,
            },
            chkFechaInicio: {
                ...chkFechaInicio,
                value: !anuncio.sFechaInicio ? false : anuncio.sFechaInicio === "Sin Fecha" ? false : true,
            },
            txtFechaInicio: {
                ...txtFechaInicio,
                value: !anuncio.sFechaInicio ? "" : anuncio.sFechaInicio === "Sin Fecha" ? "" : anuncio.dtFechaInicio,
            },
            chkFechaVencimiento: {
                ...chkFechaVencimiento,
                value: !anuncio.sFechaVencimiento ? false : anuncio.sFechaVencimiento === "Sin Fecha" ? false : true,
            },
            txtFechaVencimiento: {
                ...txtFechaVencimiento,
                value: !anuncio.sFechaVencimiento
                    ? ""
                    : anuncio.sFechaVencimiento === "Sin Fecha"
                        ? ""
                        : anuncio.dtFechaVencimiento,
            },
            txtDuracion: {
                ...txtDuracion,
                value: !anuncio.iDuracion ? "" : anuncio.iDuracion,
            },
            txtArchivo: {
                ...txtArchivo,
                value: "",
            },
        });
    };

    return (
        <AnuncioContext.Provider
            value={{
                listaAnuncios,
                anuncioSeleccionado,
                modalOpenFormAnuncio,
                modalOpenDetalleAnuncio,
                modalOpenEliminarAnuncio,
                formAnuncio,
                handleOpenFormAnuncio,
                handleOpenDetalleAnuncio,
                handleOpenEliminarAnuncio,
                handleChangeAnuncioSeleccionado,
                handleChangeFormAnuncioCheck,
                handleChangeFormAnuncioFecha,
                handleChangeFormAnuncioText,
                handleChangeFormAnuncioUInt,
                handleChangeFormAnuncioUDec,
                handleClickNuevoAnuncio,
                handleClickEditarAnuncio,
                handleClickDetalleAnuncio,
                handleClickEliminarAnuncio,
                handleClickRefrescarDatos,
                handleClickCargarArchivo,
                handleSubmitFormAnuncio,
                handleSubmitEliminarAnuncio,
            }}
        >
            {props.children}
        </AnuncioContext.Provider>
    );
}

export function useAnuncio() {
    return useContext(AnuncioContext);
}
